// extracted by mini-css-extract-plugin
export default {"linkBox":"MessengerIcons_linkBox__ePAiQ"};